import { BaseEmailCapture, BaseEmailCaptureProps } from './BaseEmailCapture'

export function DefaultEmailCapture({ onSubmit, isSuccessful, setIsSuccessful, processing }: BaseEmailCaptureProps) {
  return (
    <BaseEmailCapture
      onSubmit={onSubmit}
      isSuccessful={isSuccessful}
      setIsSuccessful={setIsSuccessful}
      processing={processing}
      title="Rate offerings change frequently"
      subtitle="Check back soon or get notified when there are updates by signing up for rate alerts."
    />
  )
}
